import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset } from '../credit-events.types';
import {
  StyledApplyOnCartButton,
  StyledAssetSelectorPanel,
  StyledAssetSelectorTitle,
  StyledCreditAssetCardsStack,
  StyledNewOrderLink,
} from '../styled';
import { CreditAssetCards } from './credit-asset-cards';

interface CreditAssetSelectorProps {
  cartAssets: CreditCartAsset[];
  onApply: (asset: OptionalAssets) => void;
  onNewOrder: () => void;
}

const CreditAssetSelector: FC<CreditAssetSelectorProps> = ({
  cartAssets,
  onApply,
  onNewOrder,
}) => {
  const { t } = useTranslation(['creditEventsModal']);
  const [selected, setSelected] = useState<OptionalAssets>(
    cartAssets[0]?.asset,
  );

  const scrollableCards = cartAssets.length >= 2;

  return (
    <StyledAssetSelectorPanel>
      <StyledAssetSelectorTitle>
        {t('creditEventsModal:selector.title')}
      </StyledAssetSelectorTitle>

      <StyledCreditAssetCardsStack isScrollable={scrollableCards}>
        <CreditAssetCards
          cartAssets={cartAssets}
          selected={selected}
          onSelect={setSelected}
        />
      </StyledCreditAssetCardsStack>

      <StyledNewOrderLink onClick={onNewOrder}>
        {t('creditEventsModal:selector.new_order')}
      </StyledNewOrderLink>

      <StyledApplyOnCartButton
        variant="primary"
        color="primary"
        fullWidth
        onClick={() => onApply(selected)}
      >
        {t('creditEventsModal:selector.apply_button')}
      </StyledApplyOnCartButton>
    </StyledAssetSelectorPanel>
  );
};

export default CreditAssetSelector;
